import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export const APPLE_PAY_AVAILABILITY_CHECKER = Symbol('APPLE_PAY_AVAILABILITY_CHECKER')


export interface ApplePayAvailabilityChecker {
  canMakeApplePayments(): boolean
}


@registerDependency(REAL, APPLE_PAY_AVAILABILITY_CHECKER)
export class RealApplePayAvailabilityChecker implements ApplePayAvailabilityChecker {
  canMakeApplePayments(): boolean {
    return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments())
  }
}


@registerDependency(FAKE, APPLE_PAY_AVAILABILITY_CHECKER)
export class FakeApplePayAvailabilityChecker implements ApplePayAvailabilityChecker {
  private available = false

  canMakeApplePayments(): boolean {
    return this.available
  }

  setAvailable(available: boolean): void {
    this.available = available
  }
}
